import api from '@/api'
export default {
  // 获取教练帐号列表
  getCoachAccount (params) {
    return api({
      url: '/integration/coach',
      method: 'GET',
      params
    })
  },
  getCoachAccountByOrg (params) {
    return api({
      url: '/integration/coach/coachListOrgan',
      method: 'GET',
      params
    })
  },
  getCoachAccountBySystem (params) {
    return api({
      url: '/integration/coach/coachListSystem',
      method: 'GET',
      params
    })
  },
  getCoachAccountByYouth (params) {
    return api({
      url: '/integration/coach/coachListYouth',
      method: 'GET',
      params
    })
  },

  getCoachBySystem (params) {
    return api({
      url: '/integration/coach/coachSystem',
      method: 'GET',
      params
    })
  },
  getCoachByYouth (params) {
    return api({
      url: '/integration/coach/coachYouth',
      method: 'GET',
      params
    })
  },
  // 添加教练员
  addCoach (data) {
    return api({
      url: '/coach/coachAdd',
      method: 'POST',
      data
    })
  },
  // 修改教练员信息
  updateCoach (data) {
    return api({
      url: '/coach/coachEdit',
      method: 'PUT',
      data
    })
  },
  // 查看教练员详细信息
  getCoachInfo (uuid) {
    return api({
      url: `/integration/coach/coachInfo/${uuid}`,
      method: 'GET'
    })
  },
  // 删除教练员
  deleteCoach (uuid) {
    return api({
      url: `/coach/${uuid}`,
      method: 'DELETE'
    })
  },
  // 批量导入教练
  batchAddCoach (data) {
    return api({
      url: '/coach/addAllByExcel',
      method: 'POST',
      data
    })
  },
  // 授权青训中心列表
  // 系统管理员 system
  getCenterListBySystem (params) {
    return api({
      url: '/youth/youthAuthorizationListSystem',
      method: 'GET',
      params
    })
  },
  // organ
  getCenterListByOrgan (organUuid) {
    return api({
      url: `/youth/youthAuthorizationListOrgan/${organUuid}`,
      method: 'GET'
    })
  },
  // youth
  getCenterListByYouth (youthUuid) {
    return api({
      url: `/youth/youthAuthorizationListYouth/${youthUuid}`,
      method: 'GET'
    })
  },
  // 获取机构、俱乐部、教练列表
  // 系统管理员 system
  getCenterCoachListBySystem (params) {
    return api({
      url: '/integration/coach/coachAuthorizationListSystem',
      method: 'GET',
      params
    })
  },
  // organ
  getCenterCoachListByOrgan () {
    return api({
      url: `/integration/coach/coachAuthorizationListOrgan`,
      method: 'GET'
    })
  },
  // youth
  getCenterCoachListByYouth () {
    return api({
      url: `/integration/coach/coachAuthorizationListYouth`,
      method: 'GET'
    })
  },
  getCenterListByOther () {
    return api({
      url: '/youth/youthAuthorizationListPerson',
      method: 'GET'
    })
  },
  // 获取敬请教练列表 -
  getCoachEliteListSystem (params) {
    return api({
      url: '/coach/coachEliteListSystem',
      method: 'GET',
      params
    })
  },
  // 添加教练员 -- 经营青训教练员 /api/zuxie/guozi/coach/coachInfoToTrain/{id_number}
  coachEliteAdd (data) {
    return api({
      url: '/coach/coachEliteAdd',
      method: 'POST',
      data
    })
  },

  getCoachInfoToTrain (idNumber) {
    return api({
      url: `/coach/coachInfoToTrain/${idNumber}`,
      method: 'GET',
    })
  },

  // 删除精英青训教练员
  deletCoachElite(uuid) {
    return api({
      url: `/coach/coachEliteDelete/${uuid}`,
      method: 'PUT'
    })
  },

  // 批量导入精英青训教练员
  importGroupCoachElite(data) {
    return api({
      url: '/coach/coachEliteTrainImport',
      method: 'POST',
      data
    })
  },

  // 获取精英教练员培训班列表 不分页
  coachClassList() {
    return api({
      url: '/coach/coachEliteTrainListAll',
      method: 'GET'
    })
  },
  getDownloadCoachAccountBySystem (params) {
    return api({
      url: '/integration/coach/downloadCoach',
      method: 'GET',
      params
    })
  },
  // 获取教练是否到期
  getCoachLimitDate (params) {
    return api({
      url: `/coach/coachLimitDate`,
      method: 'get',
      params,
    })
  },
  // 获取一个月内到期的教练
  checkCoachStatus (params) {
    return api({
      url: `/coach/checkCoachStatus`,
      method: 'get',
      params,
    })
  },
  // 添加教练员
  addcoachTeamAdd (data) {
    return api({
      url: '/coach/coachTeamAdd',
      method: 'POST',
      data
    })
  },
  addcoachTeamEdit (data) {
    return api({
      url: '/coach/coachTeamEdit',
      method: 'POST',
      data
    })
  },
  deletCoachMajor(uuid) {
    return api({
      url: `/coach/coachTeamDelete/${uuid}`,
      method: 'POST'
    })
  },
  getCenterCoachMajorList (params) {
    return api({
      url: '/coach/coachTeamList',
      method: 'GET',
      params
    })
  },
}
